import { ParentState } from "@checkout/types";
import { State } from "xstate";
import { ChFARExerciseState } from "./types";

type StateType = State<ChFARExerciseState>;
type StateWithoutValue = Pick<StateType, "context">;

export const getChfarId = (state: StateWithoutValue) =>
  state.context[ParentState.changeForAnyReasonDiscount].chfarId;
